// Generated by Avo VERSION 231.60.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "gOCEcVoZND2tX5Q6QZMG";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "rPFGgeHR7y6QvBzhI7Ir",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "ssmQGmko6B4A6Q9WPbs6",
          "se": (new Date()).toISOString(),
          "so": "Fmb0faw3Ex",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "rPFGgeHR7y6QvBzhI7Ir",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "ssmQGmko6B4A6Q9WPbs6",
          "se": (new Date()).toISOString(),
          "so": "Fmb0faw3Ex",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "ssmQGmko6B4A6Q9WPbs6",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface SaudiRewards {
  saudiRewardsEarn: boolean | null | undefined
  saudiRewardsBurn: number | null | undefined
}

export interface FilterDetail {
  filterCategory: string
  filterValues: FilterValuesValueType
}

export interface Items {
  itemId: string
  itemName: string
  itemCategory: string
  itemCategory2: string | null | undefined
  itemBrand: string
  itemListName: string
  discount: number
  index: number
  price: number
  quantity: number
}

export const Method = {
  'GOOGLE': 'Google',
  'APPLE': 'Apple',
  'EMAIL': 'Email',
} as const;
export type MethodType = typeof Method;
export type MethodValueType = MethodType[keyof MethodType];

export const Environment = {
  'DEV': 'dev',
  'STAGING': 'staging',
  'PROD': 'prod',
} as const;
export type EnvironmentType = typeof Environment;
export type EnvironmentValueType = EnvironmentType[keyof EnvironmentType];

export const FilterValues = {
  'ALL_CITIES': 'All cities',
  'ALL_UIA': 'All UIa',
  'JEDDAH': 'Jeddah',
  'RIYADH': 'Riyadh',
  'ANY_TIME': 'Any time',
  'TODAY': 'Today',
  'TOMORROW': 'Tomorrow',
  'THIS_WEEK': 'This week',
  'THIS_MONTH': 'This month',
} as const;
export type FilterValuesType = typeof FilterValues;
export type FilterValuesValueType = FilterValuesType[keyof FilterValuesType];

export const Currency = {
  'SAR': 'SAR',
} as const;
export type CurrencyType = typeof Currency;
export type CurrencyValueType = CurrencyType[keyof CurrencyType];

export const InviteSource = {
  'TRANSFER': 'transfer',
  'VENDOR': 'vendor',
  'DIRECT': 'direct',
  'NONE': 'none',
} as const;
export type InviteSourceType = typeof InviteSource;
export type InviteSourceValueType = InviteSourceType[keyof InviteSourceType];

export const Status = {
  'FAILURE': 'failure',
  'SUCCESS': 'success',
} as const;
export type StatusType = typeof Status;
export type StatusValueType = StatusType[keyof StatusType];

export const ShareMethod = {
  'WHATSAPP': 'whatsapp',
  'EMAIL': 'email',
  'QR': 'qr',
  'MESSENGER': 'messenger',
  'OTHER': 'other',
  'LINK': 'link',
  'COPY': 'copy',
} as const;
export type ShareMethodType = typeof ShareMethod;
export type ShareMethodValueType = ShareMethodType[keyof ShareMethodType];

export const PaymentType = {
  'APPLE_PAY': 'ApplePay',
  'CHECKOUT': 'Checkout',
  'FREE_OF_CHARGE': 'FreeOfCharge',
  'TABBY_PAY': 'TabbyPay',
  'TAMARA_PAY': 'TamaraPay',
} as const;
export type PaymentTypeType = typeof PaymentType;
export type PaymentTypeValueType = PaymentTypeType[keyof PaymentTypeType];

export const PlatformType = {
  'WEB': 'web',
  'APP': 'app',
} as const;
export type PlatformTypeType = typeof PlatformType;
export type PlatformTypeValueType = PlatformTypeType[keyof PlatformTypeType];

export const HostName = {
  'NOFOMO_COM': 'nofomo.com',
  'MDLBEAST_COM': 'mdlbeast.com',
} as const;
export type HostNameType = typeof HostName;
export type HostNameValueType = HostNameType[keyof HostNameType];

let sysPlatformType: any;
let sysHostName: any;
let sysEnvironment: any;

export function setSystemProperties(properties: {platformType: PlatformTypeValueType;
    hostName: HostNameValueType;
    environment: EnvironmentValueType}) {
  if (properties.platformType !== null && properties.platformType !== undefined) {
    sysPlatformType = properties.platformType;
  }
  if (properties.hostName !== null && properties.hostName !== undefined) {
    sysHostName = properties.hostName;
  }
  if (properties.environment !== null && properties.environment !== undefined) {
    sysEnvironment = properties.environment;
  }
}

let GoogleTagManagerWebContainer: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    systemProperties: {platformType: PlatformTypeValueType;
    hostName: HostNameValueType;
    environment: EnvironmentValueType},
    destinationOptions: any,
    GoogleTagManagerWebContainerDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  setSystemProperties(systemProperties);
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    GoogleTagManagerWebContainer = GoogleTagManagerWebContainerDestination;
    if (__AVO_ENV__ === 'prod') {
      GoogleTagManagerWebContainer && GoogleTagManagerWebContainer.make && GoogleTagManagerWebContainer.make(__AVO_ENV__, " GTM-TDGCWJ7F");
    } else if (__AVO_ENV__ === 'dev') {
      GoogleTagManagerWebContainer && GoogleTagManagerWebContainer.make && GoogleTagManagerWebContainer.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Google Tag Manager (Web Container). Head to destination settings in Avo to set a staging key.");
      GoogleTagManagerWebContainer && GoogleTagManagerWebContainer.make && GoogleTagManagerWebContainer.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertDiscount(discount: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertFloat("-BQq9dph9", _label ? "discount" + ': ' + _label : "discount", discount));
  messages = messages.concat(AvoAssert.assertMin("-BQq9dph9", _label ? "discount" + ": " + _label : "discount", 0.000000, discount));
  return messages;
}

function assertQuantity(quantity: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("BWpot3K9V", _label ? "quantity" + ': ' + _label : "quantity", quantity));
  messages = messages.concat(AvoAssert.assertMin("BWpot3K9V", _label ? "quantity" + ": " + _label : "quantity", 1, quantity));
  return messages;
}

function assertSaudiRewardsOptional(saudiRewards: SaudiRewards | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (saudiRewards !== undefined && saudiRewards !== null) {
    messages = messages.concat(AvoAssert.assertObject("Ct-SK7FBL_", _label ? "saudi_rewards" + ': ' + _label : "saudi_rewards", saudiRewards));
  }
  return messages;
}

function assertFilterDetail(filterDetail: FilterDetail,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertObject("X0I1PFhl3", _label ? "filter_detail" + ': ' + _label : "filter_detail", filterDetail));
  if (filterDetail !== null && filterDetail !== undefined) {
  }
  return messages;
}

function assertItems(items: Items[],
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertList("k46COD5kX", "items", items));
  if (items !== null && items !== undefined && items.forEach) {
    items.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("k46COD5kX", "item at index " + index + " in items", value));
      messages = messages.concat(assertDiscount(value.discount, "item at index " + index + " in items"));
      messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in items"));
    });
  }
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

export interface ViewItemListProperties {
  items: Items[];
  currency: CurrencyValueType;
  value: number | null | undefined;
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  clerkUserId: string | null | undefined;
}
/**
 * view_item_list: Triggered on the load of tickets popup
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/33sbcK38dn/trigger/hFppUMHKK
 * 
 * @param properties the properties associated with this event
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/33sbcK38dn}
 */
export function viewItemList(properties: ViewItemListProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  properties.value !== undefined && properties.value !== null ?
    eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value}) :
    eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: null});
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "33sbcK38dn", "d59ee9032ca9c42bc3821241c5c015c2993c4ea84f6754998384465cd11e9739", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("view_item_list", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("33sbcK38dn", "view_item_list", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'view_item_list': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item_list", eventProperties, "33sbcK38dn", "d59ee9032ca9c42bc3821241c5c015c2993c4ea84f6754998384465cd11e9739");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("view_item_list", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ViewItemProperties {
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  clerkUserId: string | null | undefined;
}
/**
 * view_item: Triggered when the ticket is viewed
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/EgJ4CAG0qT/trigger/Q68KTiEyN
 * 
 * @param properties the properties associated with this event
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/EgJ4CAG0qT}
 */
export function viewItem(properties: ViewItemProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "EgJ4CAG0qT", "d2b6e038836ff13a684f532d1fed214813ff34df45f993087c5a81c790e4ac6e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("view_item", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("EgJ4CAG0qT", "view_item", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'view_item': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item", eventProperties, "EgJ4CAG0qT", "d2b6e038836ff13a684f532d1fed214813ff34df45f993087c5a81c790e4ac6e");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("view_item", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddToCartProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  clerkUserId: string | null | undefined;
}
/**
 * add_to_cart: Triggered when the ticket is added to cart
 * 
 * When to trigger this event:
 * 1. When adding an addon item
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/fimVDbAeEK/trigger/BweB8jqOM
 * 2. When adding a ticket to the cart
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/fimVDbAeEK/trigger/9dsEWzXtN
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/fimVDbAeEK}
 */
export function addToCart(properties: AddToCartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fimVDbAeEK", "8e271bc4c1b8abd06b0000747b78645f0520dfb00c6d4d49d6577e24c92d730b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_to_cart", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fimVDbAeEK", "add_to_cart", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_to_cart': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_to_cart", eventProperties, "fimVDbAeEK", "8e271bc4c1b8abd06b0000747b78645f0520dfb00c6d4d49d6577e24c92d730b");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("add_to_cart", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface RemoveFromCartProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  clerkUserId: string | null | undefined;
}
/**
 * remove_from_cart: Triggered when the qty of a ticket is reduced or removed
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/q9pgyCNIQO}
 */
export function removeFromCart(properties: RemoveFromCartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "q9pgyCNIQO", "ed1e264a062f789ed34068f3b6e4226fe21cd2c141bec5357ac7a7bdd10c1999", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("remove_from_cart", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("q9pgyCNIQO", "remove_from_cart", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'remove_from_cart': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("remove_from_cart", eventProperties, "q9pgyCNIQO", "ed1e264a062f789ed34068f3b6e4226fe21cd2c141bec5357ac7a7bdd10c1999");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("remove_from_cart", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingSuccessProperties {
  method: MethodValueType;
  clerkUserId: string;
  userEmail: string;
  userAddress: string | null | undefined;
  userCountry: string;
  userFirstName: string;
  userLastName: string;
  userPhoneNumber: string;
  userZipcode: string | null | undefined;
  userCity: string | null | undefined;
  userGender: string | null | undefined;
}
/**
 * user_onboarding_success: Triggered when the users successfully completed the onboarding process.
 * 
 * @param properties the properties associated with this event
 * @param properties.method: Type of login/signup used.
 * @param properties.clerkUserId: The clerk user id
 * @param properties.userEmail: User email
 * @param properties.userAddress: The user address
 * @param properties.userCountry: User country
 * @param properties.userFirstName: user first name
 * @param properties.userLastName: User last name
 * @param properties.userPhoneNumber: User phone number
 * @param properties.userZipcode: user zip code
 * @param properties.userCity: Users city which they provided during onboarding
 * @param properties.userGender: Users gender which they provided during onboarding
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/05a2tzO1Or}
 */
export function userOnboardingSuccess(properties: UserOnboardingSuccessProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "7MOVTOmnB", name: "method", value: properties.method});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "rnnbCuVbM", name: "user_email", value: properties.userEmail});
  properties.userAddress !== undefined && properties.userAddress !== null ?
    eventPropertiesArray.push({id: "tMaPw4ipY", name: "user_address", value: properties.userAddress}) :
    eventPropertiesArray.push({id: "tMaPw4ipY", name: "user_address", value: null});
  eventPropertiesArray.push({id: "3u6eCTm8T", name: "user_country", value: properties.userCountry});
  eventPropertiesArray.push({id: "wTAkHMbvo", name: "user_first_name", value: properties.userFirstName});
  eventPropertiesArray.push({id: "mWyOv7lcs", name: "user_last_name", value: properties.userLastName});
  eventPropertiesArray.push({id: "kwJzDMGGV", name: "user_phone_number", value: properties.userPhoneNumber});
  properties.userZipcode !== undefined && properties.userZipcode !== null ?
    eventPropertiesArray.push({id: "Pd-z1XZnN", name: "user_zipcode", value: properties.userZipcode}) :
    eventPropertiesArray.push({id: "Pd-z1XZnN", name: "user_zipcode", value: null});
  properties.userCity !== undefined && properties.userCity !== null ?
    eventPropertiesArray.push({id: "Kj4PcLWHB", name: "user_city", value: properties.userCity}) :
    eventPropertiesArray.push({id: "Kj4PcLWHB", name: "user_city", value: null});
  properties.userGender !== undefined && properties.userGender !== null ?
    eventPropertiesArray.push({id: "aYVU-b4BQ", name: "user_gender", value: properties.userGender}) :
    eventPropertiesArray.push({id: "aYVU-b4BQ", name: "user_gender", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "05a2tzO1Or", "649232afde3c993a4a19c4511f538cc8e0523bf503da0c16154992478c95c9ae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_onboarding_success", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("05a2tzO1Or", "user_onboarding_success", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_onboarding_success", eventProperties, "05a2tzO1Or", "649232afde3c993a4a19c4511f538cc8e0523bf503da0c16154992478c95c9ae");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("user_onboarding_success", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface HomepageViewProperties {
  clerkUserId: string | null | undefined;
}
/**
 * homepage_view: Triggered on the load of homepage
 * 
 * When to trigger this event:
 * 1. When the user views the home page
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/_NRdBmLuuI/trigger/VZpplkewP
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/_NRdBmLuuI}
 */
export function homepageView(properties: HomepageViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_NRdBmLuuI", "e496e83ca04dcaa3a59557fa50e965b74d84872c80b3afe78a7fd1672f829854", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("homepage_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_NRdBmLuuI", "homepage_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("homepage_view", eventProperties, "_NRdBmLuuI", "e496e83ca04dcaa3a59557fa50e965b74d84872c80b3afe78a7fd1672f829854");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("homepage_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface GenericClickProperties {
  clickItem: string;
  originSource: string;
  originSourceCategory: string;
  clerkUserId: string | null | undefined;
}
/**
 * generic_click: Any general button click which is of interest. Eg: clicks on Get Directions, xView Lineup etc.
 * 
 * @param properties the properties associated with this event
 * @param properties.clickItem: Text of the item clicked. Currently used on; 'Get Directions', Lineup button
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/QOyE9djnuW}
 */
export function genericClick(properties: GenericClickProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "VXdqC-W4u", name: "click_item", value: properties.clickItem});
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "QOyE9djnuW", "77e84a654b6ab28ff0f8118d0c07c54fc180985e73bddefadc1b62685aeb4296", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("generic_click", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("QOyE9djnuW", "generic_click", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("generic_click", eventProperties, "QOyE9djnuW", "77e84a654b6ab28ff0f8118d0c07c54fc180985e73bddefadc1b62685aeb4296");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("generic_click", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CollectionDetailViewProperties {
  originSource: string;
  originSourceCategory: string;
  collectionName: string;
  collectionId: string;
  clerkUserId: string | null | undefined;
}
/**
 * collection_detail_view: Triggered on detail page of a collection
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/5DaTqrAV0I/trigger/VplW_OLQ0
 * 2. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/5DaTqrAV0I/trigger/bEbdJ0o4M
 * 3. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/5DaTqrAV0I/trigger/6XZj0eiaU
 * 
 * @param properties the properties associated with this event
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * @param properties.collectionName: Name of the collection from the CMS
 * slug
 * @param properties.collectionId: The id of a collection as defined in the CMS
 * record_id
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/5DaTqrAV0I}
 */
export function collectionDetailView(properties: CollectionDetailViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  eventPropertiesArray.push({id: "4cvLZD4Bu", name: "collection_name", value: properties.collectionName});
  eventPropertiesArray.push({id: "v8eyuHpt6", name: "collection_id", value: properties.collectionId});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5DaTqrAV0I", "0a862eef1ffbb827c62288d9247479df1e5c2382b1a4d914d32982002b1f26a2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("collection_detail_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5DaTqrAV0I", "collection_detail_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("collection_detail_view", eventProperties, "5DaTqrAV0I", "0a862eef1ffbb827c62288d9247479df1e5c2382b1a4d914d32982002b1f26a2");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("collection_detail_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface EventDetailViewProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  originSource: string;
  originSourceCategory: string;
  clerkUserId: string | null | undefined;
}
/**
 * event_detail_view: Triggered on the detail page of an event
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/AHzd1EI4nf/trigger/HDEwcGfDd
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/AHzd1EI4nf}
 */
export function eventDetailView(properties: EventDetailViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "AHzd1EI4nf", "8f2ac1ab4f89547a49e181789144cf926eaea70575a0d06cc22854a79ec3a0c3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("event_detail_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("AHzd1EI4nf", "event_detail_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("event_detail_view", eventProperties, "AHzd1EI4nf", "8f2ac1ab4f89547a49e181789144cf926eaea70575a0d06cc22854a79ec3a0c3");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("event_detail_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BeginCheckoutProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  clerkUserId: string;
}
/**
 * begin_checkout: Triggered when the checkout process is started
 * 
 * When to trigger this event:
 * 1. When the customers starts the checkout process by clicking on the checkout button. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/OdR_P__k2S/trigger/_EctW4YT9
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/OdR_P__k2S}
 */
export function beginCheckout(properties: BeginCheckoutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "OdR_P__k2S", "38d27b74c48b76813287a21d93baf477fe769818f06a3870e07fbe1f61e945d1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("begin_checkout", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("OdR_P__k2S", "begin_checkout", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'begin_checkout': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("begin_checkout", eventProperties, "OdR_P__k2S", "38d27b74c48b76813287a21d93baf477fe769818f06a3870e07fbe1f61e945d1");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("begin_checkout", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddShippingInfoProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  coupon: string | null | undefined;
  shippingTier: string | null | undefined;
  clerkUserId: string | null | undefined;
}
/**
 * add_shipping_info: Triggered when the user enters all the shipping information and proceeds to payment
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/wXveaqNVzE/trigger/MJc0Quz_W
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.coupon: Coupon code (if any) added by the user. Only coupon codes that have been successfully applied with a value above SAR 0.
 * @param properties.shippingTier: Type of shipping selected by the user. This can be hardcoded to Online as we don't ship the physical tickets
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/wXveaqNVzE}
 */
export function addShippingInfo(properties: AddShippingInfoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  properties.coupon !== undefined && properties.coupon !== null ?
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: properties.coupon}) :
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: null});
  properties.shippingTier !== undefined && properties.shippingTier !== null ?
    eventPropertiesArray.push({id: "T_LAE37ZZ", name: "shipping_tier", value: properties.shippingTier}) :
    eventPropertiesArray.push({id: "T_LAE37ZZ", name: "shipping_tier", value: null});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wXveaqNVzE", "e9dcd514740b4d3303879f8355dbf2aa77741cd3de13f2da33d49929a0727c6e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_shipping_info", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wXveaqNVzE", "add_shipping_info", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_shipping_info': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_shipping_info", eventProperties, "wXveaqNVzE", "e9dcd514740b4d3303879f8355dbf2aa77741cd3de13f2da33d49929a0727c6e");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("add_shipping_info", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AddPaymentInfoProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  coupon: string | null | undefined;
  paymentType: PaymentTypeValueType;
  clerkUserId: string;
}
/**
 * add_payment_info: Triggered when the user selected a payment methods and clicks on purchase tickets. 
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.coupon: Coupon code (if any) added by the user. Only coupon codes that have been successfully applied with a value above SAR 0.
 * @param properties.paymentType: Payment type selected by the user
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/PjaORHoEBI}
 */
export function addPaymentInfo(properties: AddPaymentInfoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  properties.coupon !== undefined && properties.coupon !== null ?
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: properties.coupon}) :
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: null});
  eventPropertiesArray.push({id: "kPc43o4rr", name: "payment_type", value: properties.paymentType});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PjaORHoEBI", "f148a6a8a7cb814c9f1d8e769bf5b8bc3e34ec07013297c1c1945bbe4ec10b8f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("add_payment_info", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PjaORHoEBI", "add_payment_info", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'add_payment_info': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_payment_info", eventProperties, "PjaORHoEBI", "f148a6a8a7cb814c9f1d8e769bf5b8bc3e34ec07013297c1c1945bbe4ec10b8f");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("add_payment_info", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PurchaseProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  transactionId: string;
  coupon: string | null | undefined;
  taxAmount: number;
  shippingAmount: number | null | undefined;
  paymentType: PaymentTypeValueType;
  shippingTier: string | null | undefined;
  saudiRewards: SaudiRewards | null | undefined;
  clerkUserId: string;
}
/**
 * purchase: Triggered on the successful order confirmation page
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/bUxHJ7OGpA/trigger/FZzxa07yT
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.transactionId: Unique ID of the transaction
 * @param properties.coupon: Coupon code (if any) added by the user. Only coupon codes that have been successfully applied with a value above SAR 0.
 * @param properties.taxAmount: Tax amount for the order
 * @param properties.shippingAmount: Shipping amount (if any)
 * @param properties.paymentType: Payment type selected by the user
 * @param properties.shippingTier: Type of shipping selected by the user. This can be hardcoded to Online as we don't ship the physical tickets
 * @param properties.saudiRewards: If the user has Saudi Rewards linked this object indicates additional information about earns and burns
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/bUxHJ7OGpA}
 */
export function purchase(properties: PurchaseProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "40_OZ6Pr4", name: "transaction_id", value: properties.transactionId});
  properties.coupon !== undefined && properties.coupon !== null ?
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: properties.coupon}) :
    eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: null});
  eventPropertiesArray.push({id: "cjhgdct6-", name: "tax_amount", value: properties.taxAmount});
  properties.shippingAmount !== undefined && properties.shippingAmount !== null ?
    eventPropertiesArray.push({id: "fm_xQBfoV", name: "shipping_amount", value: properties.shippingAmount}) :
    eventPropertiesArray.push({id: "fm_xQBfoV", name: "shipping_amount", value: null});
  eventPropertiesArray.push({id: "kPc43o4rr", name: "payment_type", value: properties.paymentType});
  properties.shippingTier !== undefined && properties.shippingTier !== null ?
    eventPropertiesArray.push({id: "T_LAE37ZZ", name: "shipping_tier", value: properties.shippingTier}) :
    eventPropertiesArray.push({id: "T_LAE37ZZ", name: "shipping_tier", value: null});
  properties.saudiRewards !== undefined && properties.saudiRewards !== null ?
    eventPropertiesArray.push({id: "Ct-SK7FBL_", name: "saudi_rewards", value: {
      "saudi_rewards_earn": properties.saudiRewards.saudiRewardsEarn,
      "saudi_rewards_burn": properties.saudiRewards.saudiRewardsBurn,
    }}) :
    eventPropertiesArray.push({id: "Ct-SK7FBL_", name: "saudi_rewards", value: null});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    messages = messages.concat(assertSaudiRewardsOptional(properties.saudiRewards));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "bUxHJ7OGpA", "301fe5d0984c642881f9d1d6c04c5ee11f2864c5ff1e48fb9d6092615a8fae9e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("purchase", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("bUxHJ7OGpA", "purchase", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'purchase': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase", eventProperties, "bUxHJ7OGpA", "301fe5d0984c642881f9d1d6c04c5ee11f2864c5ff1e48fb9d6092615a8fae9e");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("purchase", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchSuccessProperties {
  searchTerm: string;
  numSearchResults: number;
  filterDetail: FilterDetail;
  clerkUserId: string | null | undefined;
}
/**
 * search_success: Triggered on successful search
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/m-52WNwkgJ/trigger/B4LavlN2H
 * 
 * @param properties the properties associated with this event
 * @param properties.searchTerm: search term entered by the user
 * @param properties.numSearchResults: Number of search results shown
 * @param properties.filterDetail: Details of the filters applied by the user
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/m-52WNwkgJ}
 */
export function searchSuccess(properties: SearchSuccessProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "5u9nogbDz", name: "search_term", value: properties.searchTerm});
  eventPropertiesArray.push({id: "_-7cEg917", name: "num_search_results", value: properties.numSearchResults});
  eventPropertiesArray.push({id: "X0I1PFhl3", name: "filter_detail", value: {
    "filter_category": properties.filterDetail.filterCategory,
    "filter_values": properties.filterDetail.filterValues,
  }});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertFilterDetail(properties.filterDetail));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "m-52WNwkgJ", "ca3892b7e0c72186468c8c74d7a69169e126c381df30a0fba8cbe82828db92b8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("search_success", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("m-52WNwkgJ", "search_success", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'search_success': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("search_success", eventProperties, "m-52WNwkgJ", "ca3892b7e0c72186468c8c74d7a69169e126c381df30a0fba8cbe82828db92b8");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("search_success", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingStartProperties {
  method: MethodValueType;
  clerkUserId: string | null | undefined;
}
/**
 * user_onboarding_start: Triggered when the onboarding process starts. 
 * 
 * When to trigger this event:
 * 1. Triggered when users view the screen to create their account. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/hquWiyl4Lhu/trigger/ttOUzwJUh
 * 
 * @param properties the properties associated with this event
 * @param properties.method: Type of login/signup used.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/hquWiyl4Lhu}
 */
export function userOnboardingStart(properties: UserOnboardingStartProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "7MOVTOmnB", name: "method", value: properties.method});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hquWiyl4Lhu", "d94335489583a3d8ac3190fe584e7322f6e58ca24973f651c96e86c414b0e02f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_onboarding_start", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hquWiyl4Lhu", "user_onboarding_start", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_onboarding_start", eventProperties, "hquWiyl4Lhu", "d94335489583a3d8ac3190fe584e7322f6e58ca24973f651c96e86c414b0e02f");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("user_onboarding_start", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * magic_link_sent: Triggered when the verification email is sent
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/nTx9FQw51D/trigger/qK6zj_YVu
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/nTx9FQw51D}
 */
export function magicLinkSent() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nTx9FQw51D", "7f115118b0eeaeaee2e04a432b26ad913722d1ad223232d861b2aa553aea9fc5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("magic_link_sent", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nTx9FQw51D", "magic_link_sent", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("magic_link_sent", eventProperties, "nTx9FQw51D", "7f115118b0eeaeaee2e04a432b26ad913722d1ad223232d861b2aa553aea9fc5");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("magic_link_sent", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserLogoutProperties {
  clerkUserId: string;
}
/**
 * user_logout: Triggered when the user logs out 
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/gH7JFlOEuW}
 */
export function userLogout(properties: UserLogoutProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "gH7JFlOEuW", "a1cc2eae11285516fde69a46551fd4f37f099ab1b9e7335b97b009824eef72a1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_logout", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("gH7JFlOEuW", "user_logout", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_logout", eventProperties, "gH7JFlOEuW", "a1cc2eae11285516fde69a46551fd4f37f099ab1b9e7335b97b009824eef72a1");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("user_logout", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserAuthenticationViewProperties {
  originSource: string;
  originSourceCategory: string;
}
/**
 * user_authentication_view: Signifies the users is prompted to authenticate. 
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/N7PVC5GfnR/trigger/IS0D3DsTe
 * 2. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/N7PVC5GfnR/trigger/uH7uipOC0
 * 
 * @param properties the properties associated with this event
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/N7PVC5GfnR}
 */
export function userAuthenticationView(properties: UserAuthenticationViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "N7PVC5GfnR", "985c34ad6e5d68de75eb620242b235b3816d96e1df5fbfc98a705afd7a0f75e2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_authentication_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("N7PVC5GfnR", "user_authentication_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_authentication_view", eventProperties, "N7PVC5GfnR", "985c34ad6e5d68de75eb620242b235b3816d96e1df5fbfc98a705afd7a0f75e2");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("user_authentication_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketsOverviewViewProperties {
  numActiveEvents: string;
  originSource: string;
  originSourceCategory: string;
  clerkUserId: string | null | undefined;
}
/**
 * tickets_overview_view: Signifies the user has viewed the tickets overview
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/nXTcEU7WCw/trigger/h8G6DHgfN
 * 
 * @param properties the properties associated with this event
 * @param properties.numActiveEvents: The number of events the the users has at least a ticket for. Should only resemble the events that are not in the past.
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/nXTcEU7WCw}
 */
export function ticketsOverviewView(properties: TicketsOverviewViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "J6CSgFF2m", name: "num_active_events", value: properties.numActiveEvents});
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nXTcEU7WCw", "d66d68efd53ffea9b366984db17f80fb6563c9e9ca2e761dec284070c7ad01ce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("tickets_overview_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nXTcEU7WCw", "tickets_overview_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("tickets_overview_view", eventProperties, "nXTcEU7WCw", "d66d68efd53ffea9b366984db17f80fb6563c9e9ca2e761dec284070c7ad01ce");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("tickets_overview_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketDetailViewProperties {
  hostingEventName: string;
  eventId: string;
  eventDate: string;
  eventOrganizerId: string;
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  clerkUserId: string | null | undefined;
}
/**
 * ticket_detail_view: Signifies the user has viewed a ticket detail
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/Vj3x9Hf_J_/trigger/Bb0Mipy-1
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/Vj3x9Hf_J_}
 */
export function ticketDetailView(properties: TicketDetailViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName});
  eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId});
  eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate});
  eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId});
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Vj3x9Hf_J_", "bc70a7c720d5780b9943cd9a4cdb4368d70a818c6345847e545381982d087ee8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_detail_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Vj3x9Hf_J_", "ticket_detail_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'ticket_detail_view': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_detail_view", eventProperties, "Vj3x9Hf_J_", "bc70a7c720d5780b9943cd9a4cdb4368d70a818c6345847e545381982d087ee8");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_detail_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketInviteAcceptProperties {
  hostingEventName: string | null | undefined;
  eventId: string | null | undefined;
  eventDate: string | null | undefined;
  eventOrganizerId: string | null | undefined;
  inviteSource: InviteSourceValueType;
  clerkUserId: string;
}
/**
 * ticket_invite_accept: Triggered when the users has succesfully accepted the tickets
 * 
 * When to trigger this event:
 * 1. When the user has accepted a ticket
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/9ZnpTpM-XQ/trigger/0c-Da5QHM
 * 
 * @param properties the properties associated with this event
 * @param properties.hostingEventName: Name of the event. Eg: Erga, Soundstorm 2024 etc.
 * slug
 * @param properties.eventId: Unique ID of the event
 * id
 * @param properties.eventDate: Date of the event in YYYY-MM-DD format
 * start_datetime
 * @param properties.eventOrganizerId: Organizer of the event. Eg: MDLBeast, etc.
 * organizationId
 * @param properties.inviteSource: The source via which way the customer got invite to accept tickets.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/9ZnpTpM-XQ}
 */
export function ticketInviteAccept(properties: TicketInviteAcceptProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.hostingEventName !== undefined && properties.hostingEventName !== null ?
    eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: properties.hostingEventName}) :
    eventPropertiesArray.push({id: "fCX6czF-Y", name: "hosting_event_name", value: null});
  properties.eventId !== undefined && properties.eventId !== null ?
    eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: properties.eventId}) :
    eventPropertiesArray.push({id: "FF2LcxpeR", name: "event_id", value: null});
  properties.eventDate !== undefined && properties.eventDate !== null ?
    eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: properties.eventDate}) :
    eventPropertiesArray.push({id: "74i3Um6Ur", name: "event_date", value: null});
  properties.eventOrganizerId !== undefined && properties.eventOrganizerId !== null ?
    eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: properties.eventOrganizerId}) :
    eventPropertiesArray.push({id: "WIVxZEDQx", name: "event_organizer_id", value: null});
  eventPropertiesArray.push({id: "MVCWzWB6P", name: "invite_source", value: properties.inviteSource});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9ZnpTpM-XQ", "579ba33ea819129375e51f919333e53e54d593b5666d0193e90e0eb1b1cd9c64", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_invite_accept", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9ZnpTpM-XQ", "ticket_invite_accept", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_invite_accept", eventProperties, "9ZnpTpM-XQ", "579ba33ea819129375e51f919333e53e54d593b5666d0193e90e0eb1b1cd9c64");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_invite_accept", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketInviteViewProperties {
  inviteSource: InviteSourceValueType;
  clerkUserId: string | null | undefined;
}
/**
 * ticket_invite_view: Triggered when a users views a ticket invite, logged in or not
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/wnj8lCQm3Z/trigger/rVelS0GW7
 * 2. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/wnj8lCQm3Z/trigger/XTk3GtyN8
 * 
 * @param properties the properties associated with this event
 * @param properties.inviteSource: The source via which way the customer got invite to accept tickets.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/wnj8lCQm3Z}
 */
export function ticketInviteView(properties: TicketInviteViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "MVCWzWB6P", name: "invite_source", value: properties.inviteSource});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "wnj8lCQm3Z", "0a0e1c6a0f9623430076a8f6ffc65552123ffb2ea9656963952d15560631fc5a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_invite_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("wnj8lCQm3Z", "ticket_invite_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_invite_view", eventProperties, "wnj8lCQm3Z", "0a0e1c6a0f9623430076a8f6ffc65552123ffb2ea9656963952d15560631fc5a");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_invite_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketInviteInvalidProperties {
  clerkUserId: string | null | undefined;
  inviteSource: InviteSourceValueType;
}
/**
 * ticket_invite_invalid: Triggered when the user's ticket invite is invalid
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/uREbYVVpgV/trigger/5ivH0IUTi
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * @param properties.inviteSource: The source via which way the customer got invite to accept tickets.
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/uREbYVVpgV}
 */
export function ticketInviteInvalid(properties: TicketInviteInvalidProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "MVCWzWB6P", name: "invite_source", value: properties.inviteSource});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "uREbYVVpgV", "c7e7d7af8aa74cf0dcb8e1d72884af1c26595824fbd99a1f3e88c37ea40e4a69", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_invite_invalid", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("uREbYVVpgV", "ticket_invite_invalid", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_invite_invalid", eventProperties, "uREbYVVpgV", "c7e7d7af8aa74cf0dcb8e1d72884af1c26595824fbd99a1f3e88c37ea40e4a69");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_invite_invalid", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketTransferInitiateProperties {
  clerkUserId: string;
}
/**
 * ticket_transfer_initiate: Triggered when the user starts the flow to transfer tickets
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/tTXemTu_Ox/trigger/m47vRRMIU
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/tTXemTu_Ox}
 */
export function ticketTransferInitiate(properties: TicketTransferInitiateProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "tTXemTu_Ox", "8ebb5342965ce49b58e02e5e14fbb5f77ec9de2cfcbec2ef761bf4865e0fc0fa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_transfer_initiate", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("tTXemTu_Ox", "ticket_transfer_initiate", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_transfer_initiate", eventProperties, "tTXemTu_Ox", "8ebb5342965ce49b58e02e5e14fbb5f77ec9de2cfcbec2ef761bf4865e0fc0fa");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_transfer_initiate", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketTransferConfirmProperties {
  clerkUserId: string;
}
/**
 * ticket_transfer_confirm: Trigged when the users has confirmed the transfer of the tickets
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/7JtJFnVtAn/trigger/B5gePplIN
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/7JtJFnVtAn}
 */
export function ticketTransferConfirm(properties: TicketTransferConfirmProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7JtJFnVtAn", "d9c664546bab72f2599cb35a356947d848769b667a84dd9ed3cee2ce535b4f5d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_transfer_confirm", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7JtJFnVtAn", "ticket_transfer_confirm", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_transfer_confirm", eventProperties, "7JtJFnVtAn", "d9c664546bab72f2599cb35a356947d848769b667a84dd9ed3cee2ce535b4f5d");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_transfer_confirm", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketTransferRevokeProperties {
  clerkUserId: string;
}
/**
 * ticket_transfer_revoke: Triggered when the user has revoked the tickets transfer.
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/zPNLYjdAg7}
 */
export function ticketTransferRevoke(properties: TicketTransferRevokeProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zPNLYjdAg7", "815ac29937354786ece2be4cd78d3924cb8d679335be69036cb06ee5d0cc09ff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_transfer_revoke", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zPNLYjdAg7", "ticket_transfer_revoke", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_transfer_revoke", eventProperties, "zPNLYjdAg7", "815ac29937354786ece2be4cd78d3924cb8d679335be69036cb06ee5d0cc09ff");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_transfer_revoke", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketTransferShareProperties {
  shareMethod: ShareMethodValueType;
  clerkUserId: string;
}
/**
 * ticket_transfer_share: Triggered when the users has indicated they want to share the link to transfer the tickets
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/1dX8ufhceD/trigger/0JKLmmBeY
 * 
 * @param properties the properties associated with this event
 * @param properties.shareMethod: The method users use to share something
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/1dX8ufhceD}
 */
export function ticketTransferShare(properties: TicketTransferShareProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "goT8-nTrE", name: "share_method", value: properties.shareMethod});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1dX8ufhceD", "4e5863b15461632d6cbbe1385e491248626a9d19ae8a9e4ce0861b21b513d9d8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_transfer_share", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1dX8ufhceD", "ticket_transfer_share", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_transfer_share", eventProperties, "1dX8ufhceD", "4e5863b15461632d6cbbe1385e491248626a9d19ae8a9e4ce0861b21b513d9d8");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_transfer_share", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TicketTransferTicketsSelectionViewProperties {
  clerkUserId: string;
}
/**
 * ticket_transfer_tickets_selection_view: Triggered when the customer views the tickets selection page.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/oRSnXpmTyQ/trigger/HEGJXmSzD
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/oRSnXpmTyQ}
 */
export function ticketTransferTicketsSelectionView(properties: TicketTransferTicketsSelectionViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oRSnXpmTyQ", "e14e4437b8bc11e0c1ca5976b3b4f70d60fc61b5a561d41f367887ffe81b3a23", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("ticket_transfer_tickets_selection_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oRSnXpmTyQ", "ticket_transfer_tickets_selection_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ticket_transfer_tickets_selection_view", eventProperties, "oRSnXpmTyQ", "e14e4437b8bc11e0c1ca5976b3b4f70d60fc61b5a561d41f367887ffe81b3a23");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("ticket_transfer_tickets_selection_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CityDetailViewProperties {
  originSource: string;
  originSourceCategory: string;
  cityName: string;
  cityId: string;
  clerkUserId: string | null | undefined;
}
/**
 * city_detail_view: Triggered when the users views a city detail 
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/XXs-ZlEbrr/trigger/xtAXiflhn
 * 
 * @param properties the properties associated with this event
 * @param properties.originSource: Place from which the event originated. In case of generic clicks, this is the page where the click happened. In case of detail views, this is the section on previous screen where the user has clicked and landed on the detail view. Eg: highlights on Homepage, cities on Homepage
 * @param properties.originSourceCategory: Category the page from where the event originated. Eg: Homepage, Collection, City, Event etc.
 * @param properties.cityName: Name of the city
 * slug
 * @param properties.cityId: The id of a city as defined in the CMS
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/XXs-ZlEbrr}
 */
export function cityDetailView(properties: CityDetailViewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Ur0rsgJQd", name: "origin_source", value: properties.originSource});
  eventPropertiesArray.push({id: "dFLo90_3H", name: "origin_source_category", value: properties.originSourceCategory});
  eventPropertiesArray.push({id: "U5_TARtWq", name: "city_name", value: properties.cityName});
  eventPropertiesArray.push({id: "QiY8vuemA", name: "city_id", value: properties.cityId});
  properties.clerkUserId !== undefined && properties.clerkUserId !== null ?
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId}) :
    eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: null});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XXs-ZlEbrr", "8f49e3cf41c20b4d2fc9d74ded51248ca262dbc06c1d96379476256f6f334a6b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("city_detail_view", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XXs-ZlEbrr", "city_detail_view", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("city_detail_view", eventProperties, "XXs-ZlEbrr", "8f49e3cf41c20b4d2fc9d74ded51248ca262dbc06c1d96379476256f6f334a6b");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("city_detail_view", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserUpdateProperties {
  userCity: string;
  userEmail: string;
  userGender: string;
  userAddress: string;
  userCountry: string;
  userZipcode: string;
  userLastName: string;
  userFirstName: string;
  userPhoneNumber: string;
  clerkUserId: string;
}
/**
 * user_update: Triggered when the users updates any of their user properties
 * 
 * @param properties the properties associated with this event
 * @param properties.userCity: Users city which they provided during onboarding
 * @param properties.userEmail: User email
 * @param properties.userGender: Users gender which they provided during onboarding
 * @param properties.userAddress: The user address
 * @param properties.userCountry: User country
 * @param properties.userZipcode: user zip code
 * @param properties.userLastName: User last name
 * @param properties.userFirstName: user first name
 * @param properties.userPhoneNumber: User phone number
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/pLmW14fkeO}
 */
export function userUpdate(properties: UserUpdateProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "Kj4PcLWHB", name: "user_city", value: properties.userCity});
  eventPropertiesArray.push({id: "rnnbCuVbM", name: "user_email", value: properties.userEmail});
  eventPropertiesArray.push({id: "aYVU-b4BQ", name: "user_gender", value: properties.userGender});
  eventPropertiesArray.push({id: "tMaPw4ipY", name: "user_address", value: properties.userAddress});
  eventPropertiesArray.push({id: "3u6eCTm8T", name: "user_country", value: properties.userCountry});
  eventPropertiesArray.push({id: "Pd-z1XZnN", name: "user_zipcode", value: properties.userZipcode});
  eventPropertiesArray.push({id: "mWyOv7lcs", name: "user_last_name", value: properties.userLastName});
  eventPropertiesArray.push({id: "wTAkHMbvo", name: "user_first_name", value: properties.userFirstName});
  eventPropertiesArray.push({id: "kwJzDMGGV", name: "user_phone_number", value: properties.userPhoneNumber});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "pLmW14fkeO", "bf36d51c75e659b67a50a41ee18fbb8e119e4578118b084185986f7cf6bd4b07", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("user_update", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("pLmW14fkeO", "user_update", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("user_update", eventProperties, "pLmW14fkeO", "bf36d51c75e659b67a50a41ee18fbb8e119e4578118b084185986f7cf6bd4b07");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("user_update", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CouponCodeAddProperties {
  items: Items[];
  currency: CurrencyValueType;
  value: number;
  status: StatusValueType;
  coupon: string;
  clerkUserId: string;
}
/**
 * coupon_code_add: Triggered when a coupon is added to the cart.
 * Property "status": If successfully added and discount above SAR 0, use "success". If unsuccessful or successful but discount of SAR 0, use "failure".
 * 
 * When to trigger this event:
 * 1. When coupon is filled in and "Add coupon" is clicked.
 * View in Avo: https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/BcwUov740BvOctgK1wTbW/trigger/rkeiCZ3Sw7dO-mURBFPHh
 * 
 * @param properties the properties associated with this event
 * @param properties.items: List of item objects with all the necessary details about each ticket in consideration
 * @param properties.currency: Three Letter Currency Code in ISO 4217 format. For now, this is always SAR
 * @param properties.value: Value of the ticket being viewed/selected/added to cart/purchased. This is generally sum of all item price * qty
 * @param properties.status: Indicates if something was successful or failed.
 * @param properties.coupon: Coupon code (if any) added by the user. Only coupon codes that have been successfully applied with a value above SAR 0.
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/BcwUov740BvOctgK1wTbW}
 */
export function couponCodeAdd(properties: CouponCodeAddProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "k46COD5kX", name: "items", value: properties.items.map(function(value) { return {
      "item_id": value.itemId,
      "item_name": value.itemName,
      "item_category": value.itemCategory,
      "item_category2": value.itemCategory2,
      "item_brand": value.itemBrand,
      "item_list_name": value.itemListName,
      "discount": value.discount,
      "index": value.index,
      "price": value.price,
      "quantity": value.quantity,
    }
  })});
  eventPropertiesArray.push({id: "LtOS2iqv9", name: "currency", value: properties.currency});
  eventPropertiesArray.push({id: "lLaThK8tE", name: "value", value: properties.value});
  eventPropertiesArray.push({id: "dndeO5IQrVb2ciEmk-i41", name: "status", value: properties.status});
  eventPropertiesArray.push({id: "k3DszQBZL", name: "coupon", value: properties.coupon});
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertItems(properties.items));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BcwUov740BvOctgK1wTbW", "3f4fd7a9fdb5fe5949f24171b96d2d3c1cb9138fd78a5e5b78b7812ba2cff446", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("coupon_code_add", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BcwUov740BvOctgK1wTbW", "coupon_code_add", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'coupon_code_add': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("coupon_code_add", eventProperties, "BcwUov740BvOctgK1wTbW", "3f4fd7a9fdb5fe5949f24171b96d2d3c1cb9138fd78a5e5b78b7812ba2cff446");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("coupon_code_add", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SaudiRewardsLinkedProperties {
  clerkUserId: string;
}
/**
 * saudi_rewards_linked: Triggered when the user successfully links their Saudi Rewards account to their NOFOMO account.
 * 
 * @param properties the properties associated with this event
 * @param properties.clerkUserId: The clerk user id
 * 
 * @see {@link https://www.avo.app/schemas/ssmQGmko6B4A6Q9WPbs6/events/hPMIiKU89tREBXWSvONRF}
 */
export function saudiRewardsLinked(properties: SaudiRewardsLinkedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "QxAePksc6L", name: "clerk_user_id", value: properties.clerkUserId});
  eventPropertiesArray.push({id: "tNYRmv5ZzN", name: "platform_type", value: sysPlatformType});
  eventPropertiesArray.push({id: "zjSeaM_Q0N", name: "host_name", value: sysHostName});
  eventPropertiesArray.push({id: "CWXbgsLYPx", name: "environment", value: sysEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hPMIiKU89tREBXWSvONRF", "79ebfef8329954770aca40d2d40a74a935d664b3124b34ac7fbe9ded7024231f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("saudi_rewards_linked", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hPMIiKU89tREBXWSvONRF", "saudi_rewards_linked", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("saudi_rewards_linked", eventProperties, "hPMIiKU89tREBXWSvONRF", "79ebfef8329954770aca40d2d40a74a935d664b3124b34ac7fbe9ded7024231f");
    }
    // destination GoogleTagManagerWebContainer
    GoogleTagManagerWebContainer.logEvent("saudi_rewards_linked", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  setSystemProperties,
  avoInspectorApiKey,
  Method,
  Environment,
  FilterValues,
  Currency,
  InviteSource,
  Status,
  ShareMethod,
  PaymentType,
  PlatformType,
  HostName,
  viewItemList,
  viewItem,
  addToCart,
  removeFromCart,
  userOnboardingSuccess,
  homepageView,
  genericClick,
  collectionDetailView,
  eventDetailView,
  beginCheckout,
  addShippingInfo,
  addPaymentInfo,
  purchase,
  searchSuccess,
  userOnboardingStart,
  magicLinkSent,
  userLogout,
  userAuthenticationView,
  ticketsOverviewView,
  ticketDetailView,
  ticketInviteAccept,
  ticketInviteView,
  ticketInviteInvalid,
  ticketTransferInitiate,
  ticketTransferConfirm,
  ticketTransferRevoke,
  ticketTransferShare,
  ticketTransferTicketsSelectionView,
  cityDetailView,
  userUpdate,
  couponCodeAdd,
  saudiRewardsLinked,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["viewItemList","viewItem","addToCart","removeFromCart","userOnboardingSuccess","homepageView","genericClick","collectionDetailView","eventDetailView","beginCheckout","addShippingInfo","addPaymentInfo","purchase","searchSuccess","userOnboardingStart","magicLinkSent","userLogout","userAuthenticationView","ticketsOverviewView","ticketDetailView","ticketInviteAccept","ticketInviteView","ticketInviteInvalid","ticketTransferInitiate","ticketTransferConfirm","ticketTransferRevoke","ticketTransferShare","ticketTransferTicketsSelectionView","cityDetailView","userUpdate","couponCodeAdd","saudiRewardsLinked"]
